import { Button } from "@/components/ui/button";
import IDENTIFIERS from "@/constants/test_id";
import BackNavigator from "@/pages/components/back-navigation";
import { ChevronLeft } from "lucide-react";

import { useGroupProvider } from "@/context/group-provider";

type RegisterDisclaimerProps = {
  disclaimerText: string;
  onAgree: () => void;
  onBackToLogin: () => void;
};

const RegisterDisclaimer = ({
  disclaimerText,
  onAgree,
  onBackToLogin,
}: RegisterDisclaimerProps) => {
  const { groupData } = useGroupProvider();
  const registrationDisclaimer = disclaimerText;
  const shouldShowDisclaimer = registrationDisclaimer.trim().length > 0;

  return (
    <main className="flex h-full flex-col items-center justify-center px-8 sm:px-14">
      {shouldShowDisclaimer && (
        <>
          <BackNavigator
            title="Registration Disclaimer"
            left={
              <Button
                variant="ghost"
                aria-label="Go back"
                className="left-0 h-auto w-fit bg-transparent p-0 hover:bg-transparent hover:shadow-none focus:bg-transparent focus:shadow-none active:bg-transparent"
                onClick={() => {
                  onBackToLogin();
                }}
                data-testid={IDENTIFIERS.REGISTER.DISCLAIMER_BACK_BUTTON}
              >
                <ChevronLeft size={20} />
              </Button>
            }
          />
          <div className="flex h-4/5 max-w-sm flex-col items-center justify-center gap-12 pt-14 text-[0.875rem]">
            <div className="h-16 max-w-40">
              <img
                src={
                  groupData?.client_logo
                    ? `data:image/png;base64,${groupData.client_logo}`
                    : undefined
                }
                alt="customer logo"
                className="h-full object-contain"
              />
            </div>
            <span className="max-w-80 text-justify">
              {registrationDisclaimer}
            </span>
          </div>

          <Button
            type="button"
            size="lg"
            className="mt-8 w-40 bg-primary text-sm hover:bg-primary-selected sm:px-2"
            onClick={onAgree}
            data-testid={IDENTIFIERS.REGISTER.DISCLAIMER_AGREE_BUTTON}
          >
            Agree & Continue
          </Button>
        </>
      )}
    </main>
  );
};

export default RegisterDisclaimer;
